import React from "react";
import { AuthContextProvider } from "./AuthContext";
import { PatientsContextProvider } from "./PatientsContext";
import { MessageContextProvider } from "./MessageContext";
import { TourContextProvider } from "./TourContext";

export const AppContexts: React.FC<{}> = ({ children }) => {
  return (
    <MessageContextProvider>
      <AuthContextProvider>
        <TourContextProvider>
          <PatientsContextProvider>{children}</PatientsContextProvider>
        </TourContextProvider>
      </AuthContextProvider>
    </MessageContextProvider>
  )
}
